export default {
  "command.title": "Pair device",
  title: "Pairing",
  connection: "Local Network",
  "local.description": "View connection details and a QR code to connect a device on the same network.",
  "local.open": "Show details",
  "screenActive.title": "Keep screen active",
  "screenActive.description": "Prevent this computer’s display from sleeping while OpenCode is running.",
  "screenActive.error": "Could not update the screen activity setting. Try again.",
  description: "Connect another device to this machine's OpenCode server.",
  qr: "Pairing QR code",
  copyLink: "Copy link",
  "copy.error": "Could not copy pairing details. Try again.",
  error: "Could not update pairing details. Try again.",
  routes: "Connect with",
  "route.local": "Local network",
  "route.local.description": "Devices on the same network",
  "route.vpn": "VPN",
  "route.vpn.description": "Devices on the same VPN",
  "route.custom": "Custom address",
  "route.custom.description": "Devices that can open this address",
  "route.other": "Network address",
  "route.other.description": "Devices that can reach this address",
  expires: "Expires in {{time}}",
  refresh: "New code",
  "custom.title": "Custom address",
  "custom.description":
    "An address that reaches this computer from other devices, such as a VPN, tunnel, or reverse proxy URL.",
  "custom.placeholder": "https://opencode.example.com",
  "custom.invalid": "Enter an HTTP or HTTPS address without a path, such as https://opencode.example.com.",
  "unreachable.title": "Only this computer can reach the OpenCode server",
  "unreachable.description":
    "To pair a device on your network, run this command in a terminal, then reopen Pairing. You can also add a custom address below.",
  "unreachable.copy": "Copy command",
}
